import React, { Component } from 'react';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Login from './StaffComponents/Auth/Login';
import SetNewPassword from './StaffComponents/Auth/SetNewPassword';
import ForgotPassword from './StaffComponents/Auth/ForgotPassword';
import Register from './StaffComponents/Auth/Register';
import ConfirmAccount from './StaffComponents/Auth/ConfirmAccount';


class StaffLogin extends Component {
    constructor(props)
    {
        super(props);



        this.state = {
          collapse: false,
          showError: false,
          loading: false,
          logged_in:true,
          access_token:"",
          user_details:{},

        };


    }


  render() {
      const _this=this;

      if(this.props.loginStatus)
      {
        return(<Redirect to="/staff_ui"/>);
      }

    return (
      <div>
        <div className="wrapper wrapper-full-page">
        <div className="page-header login-page header-filter" filter-color="black">

          <div className="container">




            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-8 ml-auto mr-auto">
                <Switch>
                    <Route  exact path="/staff"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />

                    <Route  exact path="/staff/login"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />
                    <Route  exact path="/staff/setnewpassword"
                            render={(props) => <SetNewPassword {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />

                    <Route  exact path="/staff/forgotpassword"
                            render={(props) => <ForgotPassword {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />
                    <Route  exact path="/staff/register"
                            render={(props) => <Register {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />
                    <Route  exact path="/staff/verifyaccount"
                            render={(props) => <ConfirmAccount {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStaffDetails={_this.props.updateStaffDetails} />}
                    />
                </Switch>



              </div>
            </div>
          </div>
          <footer className="footer">
            <div className="container">
              <nav className="float-left">
                <ul>
                  <li>
                    <Link to="https://www.tuc.ac.ke">
                      TURKANA UNIVERSITY COLLEGE
                    </Link>
                  </li>

                </ul>
              </nav>
              <div className="copyright float-right">

              </div>
            </div>
          </footer>
        </div>
      </div>

    </div>
    );
  }


}


export default StaffLogin;
